// LLM generated - Model Claude 4 Sonnet
import { match } from 'ts-pattern';

import { SERVICE_FEE_ALERT_STATUSES } from '~/domains/contest/domains/common/constants';
import type { ServiceFeeAlertStatusType } from '~/domains/contest/domains/common/constants';
import type { Alert as GenericAlert } from '~/domains/contest/domains/services/interfaces/full-contest.interface';
import { isServiceFeeAlert as isGenericServiceFeeAlert } from '~/domains/contest/domains/services/utils/alertFilters';

import type { ServiceFeeAlert } from '../types';

/**
 * Type guard to check if a generic alert is a ServiceFee alert with proper typing
 * Validates both the alert type and required properties for ServiceFeeAlert
 */
export const isServiceFeeAlertType = (alert: GenericAlert): alert is ServiceFeeAlert =>
  isGenericServiceFeeAlert(alert) &&
  typeof alert.status === 'string' &&
  typeof alert.message === 'string';

/**
 * Maps API alert status strings to ServiceFeeAlertStatus enum values
 * @param alertStatus - The alert status string from the API
 * @returns The corresponding ServiceFeeAlertStatus enum value
 */
export const mapAlertStatus = (alertStatus: string): ServiceFeeAlertStatusType =>
  match(alertStatus)
    .with('action_required', () => SERVICE_FEE_ALERT_STATUSES.ACTION_REQUIRED)
    .with('warning', () => SERVICE_FEE_ALERT_STATUSES.WARNING)
    .with('info', () => SERVICE_FEE_ALERT_STATUSES.INFO)
    .otherwise(() => SERVICE_FEE_ALERT_STATUSES.ACTION_REQUIRED);
